import { useEffect } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

import { config } from '../routes';

const BASE_TITLE = 'Contract Builder - artificial.';

/**
 * Returns the route title from config for the current pathname.
 */
const getRouteTitle = (pathname: string): string | undefined => {
  for (const [route, routeConfig] of Object.entries(config)) {
    if (matchPath(route, pathname) && routeConfig.title) {
      return routeConfig.title;
    }
  }
  return undefined;
};

/**
 * Updates document.title based on the current route.
 *
 * Listing pages: "{page_title} - Contract Builder - artificial."
 * Contract/entity pages: overridden by useEntityDocumentTitle with entity name.
 * Fallback: "Contract Builder - artificial."
 *
 * @param dynamicName Optional dynamic name (e.g. contract name) to use instead of route title.
 */
export const useDocumentTitle = (dynamicName?: string) => {
  const { pathname } = useLocation();

  useEffect(() => {
    const routeTitle = getRouteTitle(pathname);
    const displayName = dynamicName || routeTitle;

    document.title = displayName ? `${displayName} - ${BASE_TITLE}` : BASE_TITLE;

    return () => {
      document.title = BASE_TITLE;
    };
  }, [pathname, dynamicName]);
};
